export default __webpack_public_path__ + "static/media/toilet-zone.d86a8067.jpg";